/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  EmailTrackingFull,
  EmailTrackingFullOptional,
  EmailTrackingFullMetaI,
  EmailTrackingFullTrackedI,
} from "./email-tracking-full";
import {
  EmailTrackingFullTracked,
  EmailTrackingFullMeta,
} from "./email-tracking-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupRef,
  OptOutGroupRefOptional,
  OptOutGroupRefMetaI,
  OptOutGroupRefTrackedI,
} from "./opt-out-group-ref";
import { OptOutGroupRefTracked, OptOutGroupRefMeta } from "./opt-out-group-ref";

/**
 *
 * @export
 * @interface EmailTrackingDTO
 */
export interface EmailTrackingDTOOptional extends EmailTrackingFullOptional {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  emailId?: number;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFrom?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailTo?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailSubj?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailCC?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailBCC?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridJson?: string;
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  retryCt?: number;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrName?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrOnly?: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailTrackingDTO
   */
  optOutGrpId?: OptOutGroupRefOptional;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridResp?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailPlainBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailHtmlBody?: string;
}

export interface EmailTrackingDTO
  extends EmailTrackingDTOOptional, EmailTrackingFull {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  emailId: number;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFrom?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailTo?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailSubj?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailCC?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailBCC?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridJson?: string;
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  retryCt?: number;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrName?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrOnly?: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailTrackingDTO
   */
  optOutGrpId?: OptOutGroupRef;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridResp?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailPlainBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailHtmlBody?: string;
}

export interface EmailTrackingDTOTrackedI extends EmailTrackingFullOptional {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  emailId?: number;
  emailIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFrom?: string;
  emailFromIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailTo?: string;
  emailToIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailSubj?: string;
  emailSubjIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendDatetime?: Date;
  sendDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailCC?: string;
  emailCCIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailBCC?: string;
  emailBCCIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  status?: string;
  statusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridJson?: string;
  sendgridJsonIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof EmailTrackingDTO
   */
  retryCt?: number;
  retryCtIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrName?: string;
  emailFromAddrNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailFromAddrOnly?: string;
  emailFromAddrOnlyIsSet: boolean;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailTrackingDTO
   */
  optOutGrpId?: OptOutGroupRefTrackedI;
  optOutGrpIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  sendgridResp?: string;
  sendgridRespIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailPlainBody?: string;
  emailPlainBodyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailTrackingDTO
   */
  emailHtmlBody?: string;
  emailHtmlBodyIsSet: boolean;
}

transformDatesMap.set("EmailTrackingDTO", function (model: EmailTrackingDTO) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  if (typeof model.sendDatetime == "string")
    model.sendDatetime = new Date(model.sendDatetime);
  const transformDatesoptOutGrpId = transformDatesMap.get("OptOutGroupRef");
  if (transformDatesoptOutGrpId && model.optOutGrpId) {
    transformDatesoptOutGrpId(model.optOutGrpId);
  }
});

export type EmailTrackingDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  emailId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailFrom: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailTo: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailSubj: PropertyMeta<MetaTypeBase<string>>;
  //isDate: true
  //isDatetime: false
  sendDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  emailCC: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailBCC: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  status: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sendgridJson: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  retryCt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  emailFromAddrName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailFromAddrOnly: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optOutGrpId: PropertyMeta<OptOutGroupRefMetaI>;
  //isDate: false
  //isDatetime: false
  sendgridResp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailPlainBody: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailHtmlBody: PropertyMeta<MetaTypeBase<string>>;
}>;

export var EmailTrackingDTOMeta: EmailTrackingDTOMetaI =
  {} as EmailTrackingDTOMetaI;
EmailTrackingDTOMeta = typeMeta("EmailTrackingDTO", {
  emailId: propertyMeta("emailId", false, true, true, MetaTypesBase.number),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  emailFrom: propertyMeta(
    "emailFrom",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  emailTo: propertyMeta("emailTo", false, false, false, MetaTypesBase.string),
  emailSubj: propertyMeta(
    "emailSubj",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sendDatetime: propertyMeta(
    "sendDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  emailCC: propertyMeta("emailCC", false, false, false, MetaTypesBase.string),
  emailBCC: propertyMeta("emailBCC", false, false, false, MetaTypesBase.string),
  status: propertyMeta("status", false, false, false, MetaTypesBase.string),
  sendgridJson: propertyMeta(
    "sendgridJson",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  retryCt: propertyMeta("retryCt", false, false, false, MetaTypesBase.number),
  emailFromAddrName: propertyMeta(
    "emailFromAddrName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  emailFromAddrOnly: propertyMeta(
    "emailFromAddrOnly",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optOutGrpId: propertyMeta(
    "optOutGrpId",
    false,
    false,
    false,
    OptOutGroupRefMeta,
  ),
  sendgridResp: propertyMeta(
    "sendgridResp",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  emailPlainBody: propertyMeta(
    "emailPlainBody",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  emailHtmlBody: propertyMeta(
    "emailHtmlBody",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = EmailTrackingDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([EmailTrackingFullMeta]);
  metaI.emailId.inheritedFrom = EmailTrackingFullMeta.emailId;
  metaI.updatedOn.inheritedFrom = EmailTrackingFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = EmailTrackingFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = EmailTrackingFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = EmailTrackingFullMeta.createdBy;
  metaI.emailFrom.inheritedFrom = EmailTrackingFullMeta.emailFrom;
  metaI.emailTo.inheritedFrom = EmailTrackingFullMeta.emailTo;
  metaI.emailSubj.inheritedFrom = EmailTrackingFullMeta.emailSubj;
  metaI.sendDatetime.inheritedFrom = EmailTrackingFullMeta.sendDatetime;
  metaI.emailCC.inheritedFrom = EmailTrackingFullMeta.emailCC;
  metaI.emailBCC.inheritedFrom = EmailTrackingFullMeta.emailBCC;
  metaI.status.inheritedFrom = EmailTrackingFullMeta.status;
  metaI.sendgridJson.inheritedFrom = EmailTrackingFullMeta.sendgridJson;
  metaI.retryCt.inheritedFrom = EmailTrackingFullMeta.retryCt;
  metaI.emailFromAddrName.inheritedFrom =
    EmailTrackingFullMeta.emailFromAddrName;
  metaI.emailFromAddrOnly.inheritedFrom =
    EmailTrackingFullMeta.emailFromAddrOnly;
  metaI.optOutGrpId.inheritedFrom = EmailTrackingFullMeta.optOutGrpId;
  metaI.sendgridResp.inheritedFrom = EmailTrackingFullMeta.sendgridResp;
  metaI.emailPlainBody.inheritedFrom = EmailTrackingFullMeta.emailPlainBody;
  metaI.emailHtmlBody.inheritedFrom = EmailTrackingFullMeta.emailHtmlBody;
});

export class EmailTrackingDTOTracked
  extends EmailTrackingFullTracked
  implements EmailTrackingDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  emailId__I?: number = undefined;

  get emailIdIsSet() {
    return this.emailId !== undefined;
  }
  set emailIdIsSet(v: boolean) {}
  set emailId(v: undefined | number) {
    if (v !== undefined) {
      this.emailId__I = v;
      this.emailIdIsSet = true;
    } else {
      this.emailId__I = v || undefined;
      this.emailIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get emailId() {
    return this.emailId__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  emailFrom__I?: string = undefined;
  emailFromIsSet: boolean = false;
  set emailFrom(v: undefined | string) {
    if (v !== undefined) {
      this.emailFrom__I = v;
      this.emailFromIsSet = true;
    } else {
      this.emailFrom__I = v || undefined;
      this.emailFromIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailFrom() {
    return this.emailFrom__I;
  }
  emailTo__I?: string = undefined;
  emailToIsSet: boolean = false;
  set emailTo(v: undefined | string) {
    if (v !== undefined) {
      this.emailTo__I = v;
      this.emailToIsSet = true;
    } else {
      this.emailTo__I = v || undefined;
      this.emailToIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailTo() {
    return this.emailTo__I;
  }
  emailSubj__I?: string = undefined;
  emailSubjIsSet: boolean = false;
  set emailSubj(v: undefined | string) {
    if (v !== undefined) {
      this.emailSubj__I = v;
      this.emailSubjIsSet = true;
    } else {
      this.emailSubj__I = v || undefined;
      this.emailSubjIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailSubj() {
    return this.emailSubj__I;
  }
  sendDatetime__I?: Date = undefined;
  sendDatetimeIsSet: boolean = false;
  set sendDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sendDatetime__I = v;
      this.sendDatetimeIsSet = true;
    } else {
      this.sendDatetime__I = v || undefined;
      this.sendDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sendDatetime() {
    return this.sendDatetime__I;
  }
  emailCC__I?: string = undefined;
  emailCCIsSet: boolean = false;
  set emailCC(v: undefined | string) {
    if (v !== undefined) {
      this.emailCC__I = v;
      this.emailCCIsSet = true;
    } else {
      this.emailCC__I = v || undefined;
      this.emailCCIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailCC() {
    return this.emailCC__I;
  }
  emailBCC__I?: string = undefined;
  emailBCCIsSet: boolean = false;
  set emailBCC(v: undefined | string) {
    if (v !== undefined) {
      this.emailBCC__I = v;
      this.emailBCCIsSet = true;
    } else {
      this.emailBCC__I = v || undefined;
      this.emailBCCIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailBCC() {
    return this.emailBCC__I;
  }
  status__I?: string = undefined;
  statusIsSet: boolean = false;
  set status(v: undefined | string) {
    if (v !== undefined) {
      this.status__I = v;
      this.statusIsSet = true;
    } else {
      this.status__I = v || undefined;
      this.statusIsSet = false;
    }
    this.changeTracker = true;
  }
  get status() {
    return this.status__I;
  }
  sendgridJson__I?: string = undefined;
  sendgridJsonIsSet: boolean = false;
  set sendgridJson(v: undefined | string) {
    if (v !== undefined) {
      this.sendgridJson__I = v;
      this.sendgridJsonIsSet = true;
    } else {
      this.sendgridJson__I = v || undefined;
      this.sendgridJsonIsSet = false;
    }
    this.changeTracker = true;
  }
  get sendgridJson() {
    return this.sendgridJson__I;
  }
  retryCt__I?: number = undefined;
  retryCtIsSet: boolean = false;
  set retryCt(v: undefined | number) {
    if (v !== undefined) {
      this.retryCt__I = v;
      this.retryCtIsSet = true;
    } else {
      this.retryCt__I = v || undefined;
      this.retryCtIsSet = false;
    }
    this.changeTracker = true;
  }
  get retryCt() {
    return this.retryCt__I;
  }
  emailFromAddrName__I?: string = undefined;
  emailFromAddrNameIsSet: boolean = false;
  set emailFromAddrName(v: undefined | string) {
    if (v !== undefined) {
      this.emailFromAddrName__I = v;
      this.emailFromAddrNameIsSet = true;
    } else {
      this.emailFromAddrName__I = v || undefined;
      this.emailFromAddrNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailFromAddrName() {
    return this.emailFromAddrName__I;
  }
  emailFromAddrOnly__I?: string = undefined;
  emailFromAddrOnlyIsSet: boolean = false;
  set emailFromAddrOnly(v: undefined | string) {
    if (v !== undefined) {
      this.emailFromAddrOnly__I = v;
      this.emailFromAddrOnlyIsSet = true;
    } else {
      this.emailFromAddrOnly__I = v || undefined;
      this.emailFromAddrOnlyIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailFromAddrOnly() {
    return this.emailFromAddrOnly__I;
  }
  optOutGrpId__I?: OptOutGroupRefTracked = undefined;
  optOutGrpIdIsSet: boolean = false;
  set optOutGrpId(v: undefined | OptOutGroupRefTracked) {
    if (v !== undefined) {
      this.optOutGrpId__I = v;
      this.optOutGrpIdIsSet = true;
    } else {
      this.optOutGrpId__I = v || undefined;
      this.optOutGrpIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get optOutGrpId() {
    return this.optOutGrpId__I;
  }
  sendgridResp__I?: string = undefined;
  sendgridRespIsSet: boolean = false;
  set sendgridResp(v: undefined | string) {
    if (v !== undefined) {
      this.sendgridResp__I = v;
      this.sendgridRespIsSet = true;
    } else {
      this.sendgridResp__I = v || undefined;
      this.sendgridRespIsSet = false;
    }
    this.changeTracker = true;
  }
  get sendgridResp() {
    return this.sendgridResp__I;
  }
  emailPlainBody__I?: string = undefined;
  emailPlainBodyIsSet: boolean = false;
  set emailPlainBody(v: undefined | string) {
    if (v !== undefined) {
      this.emailPlainBody__I = v;
      this.emailPlainBodyIsSet = true;
    } else {
      this.emailPlainBody__I = v || undefined;
      this.emailPlainBodyIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailPlainBody() {
    return this.emailPlainBody__I;
  }
  emailHtmlBody__I?: string = undefined;
  emailHtmlBodyIsSet: boolean = false;
  set emailHtmlBody(v: undefined | string) {
    if (v !== undefined) {
      this.emailHtmlBody__I = v;
      this.emailHtmlBodyIsSet = true;
    } else {
      this.emailHtmlBody__I = v || undefined;
      this.emailHtmlBodyIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailHtmlBody() {
    return this.emailHtmlBody__I;
  }
  constructor(config?: EmailTrackingDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.emailIdIsSet == true && other?.emailIdIsSet == true)
      return this.emailId == other.emailId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.emailId) {
      this.emailIdIsSet = true;
    }

    this.optOutGrpId?.setIds();
  }
  assignFrom(
    config: EmailTrackingDTOOptional,
    options?: AssignOptions,
  ): EmailTrackingDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.emailId && this.emailIdApplyFilter(optionsRequired.filter)) {
      this.emailId = config.emailId;
      if (optionsRequired.unassign) this.emailIdIsSet = false;
      else this.emailIdIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.emailFrom && this.emailFromApplyFilter(optionsRequired.filter)) {
      this.emailFrom = config.emailFrom;
      if (optionsRequired.unassign) this.emailFromIsSet = false;
      else this.emailFromIsSet = true;
    }
    if (config.emailTo && this.emailToApplyFilter(optionsRequired.filter)) {
      this.emailTo = config.emailTo;
      if (optionsRequired.unassign) this.emailToIsSet = false;
      else this.emailToIsSet = true;
    }
    if (config.emailSubj && this.emailSubjApplyFilter(optionsRequired.filter)) {
      this.emailSubj = config.emailSubj;
      if (optionsRequired.unassign) this.emailSubjIsSet = false;
      else this.emailSubjIsSet = true;
    }
    if (
      config.sendDatetime &&
      this.sendDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sendDatetime = config.sendDatetime;
      if (optionsRequired.unassign) this.sendDatetimeIsSet = false;
      else this.sendDatetimeIsSet = true;
    }
    if (config.emailCC && this.emailCCApplyFilter(optionsRequired.filter)) {
      this.emailCC = config.emailCC;
      if (optionsRequired.unassign) this.emailCCIsSet = false;
      else this.emailCCIsSet = true;
    }
    if (config.emailBCC && this.emailBCCApplyFilter(optionsRequired.filter)) {
      this.emailBCC = config.emailBCC;
      if (optionsRequired.unassign) this.emailBCCIsSet = false;
      else this.emailBCCIsSet = true;
    }
    if (config.status && this.statusApplyFilter(optionsRequired.filter)) {
      this.status = config.status;
      if (optionsRequired.unassign) this.statusIsSet = false;
      else this.statusIsSet = true;
    }
    if (
      config.sendgridJson &&
      this.sendgridJsonApplyFilter(optionsRequired.filter)
    ) {
      this.sendgridJson = config.sendgridJson;
      if (optionsRequired.unassign) this.sendgridJsonIsSet = false;
      else this.sendgridJsonIsSet = true;
    }
    if (config.retryCt && this.retryCtApplyFilter(optionsRequired.filter)) {
      this.retryCt = config.retryCt;
      if (optionsRequired.unassign) this.retryCtIsSet = false;
      else this.retryCtIsSet = true;
    }
    if (
      config.emailFromAddrName &&
      this.emailFromAddrNameApplyFilter(optionsRequired.filter)
    ) {
      this.emailFromAddrName = config.emailFromAddrName;
      if (optionsRequired.unassign) this.emailFromAddrNameIsSet = false;
      else this.emailFromAddrNameIsSet = true;
    }
    if (
      config.emailFromAddrOnly &&
      this.emailFromAddrOnlyApplyFilter(optionsRequired.filter)
    ) {
      this.emailFromAddrOnly = config.emailFromAddrOnly;
      if (optionsRequired.unassign) this.emailFromAddrOnlyIsSet = false;
      else this.emailFromAddrOnlyIsSet = true;
    }
    if (
      config.optOutGrpId &&
      this.optOutGrpIdApplyFilter(optionsRequired.filter)
    ) {
      this.optOutGrpId = new OptOutGroupRefTracked(config.optOutGrpId, options);
      if (optionsRequired.unassign) this.optOutGrpIdIsSet = false;
      else this.optOutGrpIdIsSet = true;
    }
    if (
      config.sendgridResp &&
      this.sendgridRespApplyFilter(optionsRequired.filter)
    ) {
      this.sendgridResp = config.sendgridResp;
      if (optionsRequired.unassign) this.sendgridRespIsSet = false;
      else this.sendgridRespIsSet = true;
    }
    if (
      config.emailPlainBody &&
      this.emailPlainBodyApplyFilter(optionsRequired.filter)
    ) {
      this.emailPlainBody = config.emailPlainBody;
      if (optionsRequired.unassign) this.emailPlainBodyIsSet = false;
      else this.emailPlainBodyIsSet = true;
    }
    if (
      config.emailHtmlBody &&
      this.emailHtmlBodyApplyFilter(optionsRequired.filter)
    ) {
      this.emailHtmlBody = config.emailHtmlBody;
      if (optionsRequired.unassign) this.emailHtmlBodyIsSet = false;
      else this.emailHtmlBodyIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailTrackingDTOTrackedI {
    const cloned = {} as EmailTrackingDTOTrackedI;
    if (
      this.emailIdIsSetDeep() &&
      this.emailIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIdIsSet = true;
      cloned.emailId = this.emailId;
    } else {
      //cloned.emailIdIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.emailFromIsSetDeep() &&
      this.emailFromApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailFromIsSet = true;
      cloned.emailFrom = this.emailFrom;
    } else {
      //cloned.emailFromIsSet = false
    }
    if (
      this.emailToIsSetDeep() &&
      this.emailToApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailToIsSet = true;
      cloned.emailTo = this.emailTo;
    } else {
      //cloned.emailToIsSet = false
    }
    if (
      this.emailSubjIsSetDeep() &&
      this.emailSubjApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailSubjIsSet = true;
      cloned.emailSubj = this.emailSubj;
    } else {
      //cloned.emailSubjIsSet = false
    }
    if (
      this.sendDatetimeIsSetDeep() &&
      this.sendDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sendDatetimeIsSet = true;
      cloned.sendDatetime = this.sendDatetime;
    } else {
      //cloned.sendDatetimeIsSet = false
    }
    if (
      this.emailCCIsSetDeep() &&
      this.emailCCApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailCCIsSet = true;
      cloned.emailCC = this.emailCC;
    } else {
      //cloned.emailCCIsSet = false
    }
    if (
      this.emailBCCIsSetDeep() &&
      this.emailBCCApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailBCCIsSet = true;
      cloned.emailBCC = this.emailBCC;
    } else {
      //cloned.emailBCCIsSet = false
    }
    if (
      this.statusIsSetDeep() &&
      this.statusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.statusIsSet = true;
      cloned.status = this.status;
    } else {
      //cloned.statusIsSet = false
    }
    if (
      this.sendgridJsonIsSetDeep() &&
      this.sendgridJsonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sendgridJsonIsSet = true;
      cloned.sendgridJson = this.sendgridJson;
    } else {
      //cloned.sendgridJsonIsSet = false
    }
    if (
      this.retryCtIsSetDeep() &&
      this.retryCtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.retryCtIsSet = true;
      cloned.retryCt = this.retryCt;
    } else {
      //cloned.retryCtIsSet = false
    }
    if (
      this.emailFromAddrNameIsSetDeep() &&
      this.emailFromAddrNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailFromAddrNameIsSet = true;
      cloned.emailFromAddrName = this.emailFromAddrName;
    } else {
      //cloned.emailFromAddrNameIsSet = false
    }
    if (
      this.emailFromAddrOnlyIsSetDeep() &&
      this.emailFromAddrOnlyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailFromAddrOnlyIsSet = true;
      cloned.emailFromAddrOnly = this.emailFromAddrOnly;
    } else {
      //cloned.emailFromAddrOnlyIsSet = false
    }
    if (
      this.optOutGrpIdIsSetDeep() &&
      this.optOutGrpIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutGrpIdIsSet = true;
      cloned.optOutGrpId = this.optOutGrpId?.removeUnset(filter);
    } else {
      //cloned.optOutGrpIdIsSet = false
    }
    if (
      this.sendgridRespIsSetDeep() &&
      this.sendgridRespApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sendgridRespIsSet = true;
      cloned.sendgridResp = this.sendgridResp;
    } else {
      //cloned.sendgridRespIsSet = false
    }
    if (
      this.emailPlainBodyIsSetDeep() &&
      this.emailPlainBodyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailPlainBodyIsSet = true;
      cloned.emailPlainBody = this.emailPlainBody;
    } else {
      //cloned.emailPlainBodyIsSet = false
    }
    if (
      this.emailHtmlBodyIsSetDeep() &&
      this.emailHtmlBodyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailHtmlBodyIsSet = true;
      cloned.emailHtmlBody = this.emailHtmlBody;
    } else {
      //cloned.emailHtmlBodyIsSet = false
    }
    if (!isDeleted(this) && !this.emailIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailTrackingDTOTrackedI {
    if (!this.emailIdApplyFilter(filter)) this.emailIdIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.emailFromApplyFilter(filter)) this.emailFromIsSet = false;

    if (!this.emailToApplyFilter(filter)) this.emailToIsSet = false;

    if (!this.emailSubjApplyFilter(filter)) this.emailSubjIsSet = false;

    if (!this.sendDatetimeApplyFilter(filter)) this.sendDatetimeIsSet = false;

    if (!this.emailCCApplyFilter(filter)) this.emailCCIsSet = false;

    if (!this.emailBCCApplyFilter(filter)) this.emailBCCIsSet = false;

    if (!this.statusApplyFilter(filter)) this.statusIsSet = false;

    if (!this.sendgridJsonApplyFilter(filter)) this.sendgridJsonIsSet = false;

    if (!this.retryCtApplyFilter(filter)) this.retryCtIsSet = false;

    if (!this.emailFromAddrNameApplyFilter(filter))
      this.emailFromAddrNameIsSet = false;

    if (!this.emailFromAddrOnlyApplyFilter(filter))
      this.emailFromAddrOnlyIsSet = false;

    if (!this.optOutGrpIdApplyFilter(filter)) this.optOutGrpIdIsSet = false;
    this.optOutGrpId?.unassignAll(filter);

    if (!this.sendgridRespApplyFilter(filter)) this.sendgridRespIsSet = false;

    if (!this.emailPlainBodyApplyFilter(filter))
      this.emailPlainBodyIsSet = false;

    if (!this.emailHtmlBodyApplyFilter(filter)) this.emailHtmlBodyIsSet = false;

    return this;
  }
  emailIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailId,
      EmailTrackingDTOMeta,
      this.emailId,
      this,
    );
  }
  emailIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIdIsSet && this.emailIdApplyFilter(filter)) return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.updatedOn,
      EmailTrackingDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.updatedBy,
      EmailTrackingDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.createdOn,
      EmailTrackingDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.createdBy,
      EmailTrackingDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  emailFromApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailFrom,
      EmailTrackingDTOMeta,
      this.emailFrom,
      this,
    );
  }
  emailFromIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailFromIsSet && this.emailFromApplyFilter(filter)) return true;

    return false;
  }
  emailToApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailTo,
      EmailTrackingDTOMeta,
      this.emailTo,
      this,
    );
  }
  emailToIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailToIsSet && this.emailToApplyFilter(filter)) return true;

    return false;
  }
  emailSubjApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailSubj,
      EmailTrackingDTOMeta,
      this.emailSubj,
      this,
    );
  }
  emailSubjIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailSubjIsSet && this.emailSubjApplyFilter(filter)) return true;

    return false;
  }
  sendDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.sendDatetime,
      EmailTrackingDTOMeta,
      this.sendDatetime,
      this,
    );
  }
  sendDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sendDatetimeIsSet && this.sendDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  emailCCApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailCC,
      EmailTrackingDTOMeta,
      this.emailCC,
      this,
    );
  }
  emailCCIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailCCIsSet && this.emailCCApplyFilter(filter)) return true;

    return false;
  }
  emailBCCApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailBCC,
      EmailTrackingDTOMeta,
      this.emailBCC,
      this,
    );
  }
  emailBCCIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailBCCIsSet && this.emailBCCApplyFilter(filter)) return true;

    return false;
  }
  statusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.status,
      EmailTrackingDTOMeta,
      this.status,
      this,
    );
  }
  statusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.statusIsSet && this.statusApplyFilter(filter)) return true;

    return false;
  }
  sendgridJsonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.sendgridJson,
      EmailTrackingDTOMeta,
      this.sendgridJson,
      this,
    );
  }
  sendgridJsonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sendgridJsonIsSet && this.sendgridJsonApplyFilter(filter))
      return true;

    return false;
  }
  retryCtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.retryCt,
      EmailTrackingDTOMeta,
      this.retryCt,
      this,
    );
  }
  retryCtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.retryCtIsSet && this.retryCtApplyFilter(filter)) return true;

    return false;
  }
  emailFromAddrNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailFromAddrName,
      EmailTrackingDTOMeta,
      this.emailFromAddrName,
      this,
    );
  }
  emailFromAddrNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.emailFromAddrNameIsSet &&
      this.emailFromAddrNameApplyFilter(filter)
    )
      return true;

    return false;
  }
  emailFromAddrOnlyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailFromAddrOnly,
      EmailTrackingDTOMeta,
      this.emailFromAddrOnly,
      this,
    );
  }
  emailFromAddrOnlyIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.emailFromAddrOnlyIsSet &&
      this.emailFromAddrOnlyApplyFilter(filter)
    )
      return true;

    return false;
  }
  optOutGrpIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.optOutGrpId,
      EmailTrackingDTOMeta,
      this.optOutGrpId,
      this,
    );
  }
  optOutGrpIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutGrpIdIsSet && this.optOutGrpIdApplyFilter(filter))
      return true;
    return this.optOutGrpId?.anySet(filter) == true;

    return false;
  }
  sendgridRespApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.sendgridResp,
      EmailTrackingDTOMeta,
      this.sendgridResp,
      this,
    );
  }
  sendgridRespIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sendgridRespIsSet && this.sendgridRespApplyFilter(filter))
      return true;

    return false;
  }
  emailPlainBodyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailPlainBody,
      EmailTrackingDTOMeta,
      this.emailPlainBody,
      this,
    );
  }
  emailPlainBodyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailPlainBodyIsSet && this.emailPlainBodyApplyFilter(filter))
      return true;

    return false;
  }
  emailHtmlBodyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingDTOMeta.emailHtmlBody,
      EmailTrackingDTOMeta,
      this.emailHtmlBody,
      this,
    );
  }
  emailHtmlBodyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailHtmlBodyIsSet && this.emailHtmlBodyApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.emailIdIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.emailFromIsSetDeep(filter)) return true;
    if (this.emailToIsSetDeep(filter)) return true;
    if (this.emailSubjIsSetDeep(filter)) return true;
    if (this.sendDatetimeIsSetDeep(filter)) return true;
    if (this.emailCCIsSetDeep(filter)) return true;
    if (this.emailBCCIsSetDeep(filter)) return true;
    if (this.statusIsSetDeep(filter)) return true;
    if (this.sendgridJsonIsSetDeep(filter)) return true;
    if (this.retryCtIsSetDeep(filter)) return true;
    if (this.emailFromAddrNameIsSetDeep(filter)) return true;
    if (this.emailFromAddrOnlyIsSetDeep(filter)) return true;
    if (this.optOutGrpIdIsSetDeep(filter)) return true;
    if (this.sendgridRespIsSetDeep(filter)) return true;
    if (this.emailPlainBodyIsSetDeep(filter)) return true;
    if (this.emailHtmlBodyIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
